import { CapabilityPermissionRepository } from "@domain/capability-permission/repositories/capability-permission.repository";
import { CapabilityPermissionRepositoryService } from "../repositories/capability-permission.service";

export const CapabilityPermissionProvider = [
    {
      provide: CapabilityPermissionRepository,
      useClass: CapabilityPermissionRepositoryService,
    },
  ];
  